import { BoundedContent, Box } from '@vp/swan';
import { useInVistaExperimentVariant } from '@99designs/experiments';
import { ServiceDetailsPageDataQuery } from '../../../../graphql';
import { FAQSection } from '../../../FAQSection';
import { HowItWorks } from '../HowItWorks';
import { TierComparison } from '../TierComparison';
import { TierHeroBanner } from '../TierHeroBanner';
import { TierNavBar } from '../TierNavBar';
import { productConfig } from '../pageData/productConfig';
import { TierLocale } from '../pageData/tierConfig';
import {
    ComparePackagesSectionId,
    FAQSectionId,
    HowItWorksSectionId,
    tierServiceDetailPage,
} from '../pageData/tierServiceDetailPage';
import type { MpvId } from '../pageData/productConfig';

export type Images = ServiceDetailsPageDataQuery['serviceDetailPage']['heroImages'];

interface TierLayoutProps {
    mpvId: string;
    productName: string;
    locale: TierLocale;
    heroImages: Images;
}

export function TierLayout({ mpvId, locale, productName, heroImages }: TierLayoutProps) {
    const { faqs, nav } = tierServiceDetailPage;
    const inVariant = useInVistaExperimentVariant('design_services_sdp_turnaround_time');
    const isVariant3Day = locale === 'en-US' ? inVariant('variant_3_day') ?? false : false;
    const product = productConfig[mpvId as MpvId];
    const tiers = product.getTiers(locale, { useExperimentVariants: isVariant3Day });

    return (
        <>
            <Box>
                <BoundedContent>
                    <TierHeroBanner
                        title={productName}
                        tiers={tiers}
                        locale={locale}
                        heroImages={heroImages}
                    />
                </BoundedContent>
            </Box>
            <Box mb="between-sections" mt={3}>
                <TierNavBar navItems={nav} />
            </Box>
            <Box mb="between-sections" id={ComparePackagesSectionId}>
                <BoundedContent>
                    <TierComparison tiers={tiers} />
                </BoundedContent>
            </Box>
            <Box mb="between-sections" id={HowItWorksSectionId}>
                <HowItWorks />
            </Box>
            <Box id={FAQSectionId}>
                <FAQSection faqs={faqs} />
            </Box>
        </>
    );
}
